import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#098D46",
      d: "m5.183 8.683 4.113-4.112-.817-.817L5.183 7.05 3.521 5.388l-.817.816zM6 11.833a5.7 5.7 0 0 1-2.275-.459 5.9 5.9 0 0 1-1.852-1.247A5.9 5.9 0 0 1 .626 8.275 5.7 5.7 0 0 1 .166 6q0-1.21.46-2.275a5.9 5.9 0 0 1 1.247-1.852A5.9 5.9 0 0 1 3.725.626 5.7 5.7 0 0 1 6 .166a5.7 5.7 0 0 1 2.275.46q1.065.46 1.852 1.247a5.9 5.9 0 0 1 1.247 1.852q.46 1.065.46 2.275a5.7 5.7 0 0 1-.46 2.275 5.9 5.9 0 0 1-1.247 1.852 5.9 5.9 0 0 1-1.852 1.247 5.7 5.7 0 0 1-2.275.46"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "success"}) } }